<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17hoXPn/tc-custom/9780226793948.jpg?1732162721377" alt="This image is the cover for the book Artful Truths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Artful Truths
      </h1>
      <p class="bookDescription body article font2">
        <b>Offers a philosophical perspective on the nature and value of writing a memoir.</b><br/>  <br/><i>Artful Truths</i> offers a concise guide to the fundamental philosophical questions that arise when writing a literary work about your own life. Bringing a philosopher’s perspective to a general audience, Helena de Bres addresses what a memoir is, how the genre relates to fiction, memoirists’ responsibilities to their readers and subjects, and the question of why to write a memoir at all. Along the way, she delves into a wide range of philosophical issues, including the nature of the self, the limits of knowledge, the idea of truth, the obligations of friendship, the relationship between morality and art, and the question of what makes a life meaningful.<br/>  <br/> Written in a clear and conversational style, it offers a resource for those who write, teach, and study memoirs, as well as those who love to read them. With a combination of literary and philosophical knowledge, de Bres takes the many challenges directed at memoirists seriously, while ultimately standing in defense of a genre that, for all its perplexities—and maybe partly because of them—continually proves to be both beloved and valuable. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helena de Bres
      </h2>
      
      <p class="authorDescription body article"><B>Helena de Bres</B> is associate professor of philosophy at Wellesley College. Her personal essays, public philosophy, and humor writing have appeared in <I>The Point</I>, <I>New York Times</I>, <I>Rumpus</I>, <I>Aeon Magazine</I>, and <I>McSweeney’s Internet Tendency</I>, and she’s currently writing a memoir about the nature and value of philosophy.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6784a638